import { isNil } from 'lodash';
import pako from 'pako';
import { Cookies } from 'react-cookie';

import { axios } from '@bai/data';
import {
  AngularServiceNames,
  getAngularService,
} from '@bai/features/angular-integration';
import { addValueToGlobals, basePath } from '@bai/utils';
import { RoleNames, StorageVariables } from '@bai/utils/types';
import type { Auth } from '@bai/utils/types';

export const CookieStore = new Cookies();

export function parseAuthFromCookie(cookie?: string): Auth | null {
  if (!isNil(cookie)) {
    try {
      // NOTE: This implementation is copied and slightly modified from the legacy implementation
      // You can find an example of the legacy implementation here: https://dev.azure.com/baidotorg/learning-manager/_git/lms?path=web/BAI.LMS.Web/App/js/services/user.js&version=GC0b62161318d8e020f5a63a37bd2b1c9d5bd4c246&line=819&lineStartColumn=1&lineEndColumn=1&_a=contents
      const decoded = atob(cookie);
      const inflated = pako.inflate(decoded);
      const uint8array = new Uint8Array(inflated);
      const parsedAsString: string = String.fromCharCode(...uint8array);
      const parsedUser: Auth | undefined = JSON.parse(parsedAsString) as Auth;
      return parsedUser ?? null;
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function refreshCookieStore() {
  CookieStore.set('LEGACY_COOKIE', `${Math.random()}`);

  addValueToGlobals('refreshCookieStore', refreshCookieStore);
}

export interface LoginParams {
  username: string;
  password: string;
}

export async function login({
  username,
  password,
}: LoginParams): Promise<Auth> {
  const resp = await axios.post<Auth>('api/account/login', {
    Password: password,
    UserName: username,
  });

  /* Update Angular's UserService state */
  const userService = getAngularService(AngularServiceNames.USER_SERVICE);
  userService.updateFromReact?.(resp.data);

  refreshCookieStore();

  return resp.data;
}

export async function logout(portalCode?: string): Promise<void> {
  await axios.post<string>('api/account/logout');

  window.location.href =
    isNil(portalCode) || portalCode === ''
      ? basePath
      : `${basePath}?portal=${portalCode}`;

  sessionStorage.removeItem(StorageVariables.disableDashboard);
}

/**
 * setUserRole is used for legacy purposes only.
 *
 * It updates the in-memory and in-cookie value for the current role of the user.
 *
 * These values are not used within React.
 *
 */
export async function setUserRole(role: RoleNames) {
  const userService = getAngularService(AngularServiceNames.USER_SERVICE);
  return userService.setUserContext?.(role);
}
